import React, { memo, useEffect } from "react";
import { validators } from "investira.sdk";
import { Stack, Divider } from "investira.react.components";
import ConsultaProvider from "../../../../contexts/ConsultaContext";
import useKickBack from "../../../../hooks/useKickBack";
import withMessage from "../../../../hoc/withMessage";
import PlanoPosicao from "../PlanoPosicao";
import Cenarios from "./Cenarios";
import Highlights from "./Highlights";
import Graphs from "./Graphs";

const ConsultaStressTest = memo((props) => {
  const { data } = props;
  const kick = useKickBack();

  useEffect(() => {
    kick && props.onMessage("Entidade alterada");
  }, [kick]);

  if (validators.isEmpty(data)) {
    return null;
  }

  return (
    <ConsultaProvider>
      <Stack spacing={2}>
        <PlanoPosicao
          beta={false}
          created={data.request?.data}
          carteira={data.request_metadata?.carteira}
        />
        <Divider />
        <Stack sx={{ gap: 2 }} component="section">
          <Highlights data={data} />
          {/* TODO: ADD Gráficos do impacto por ativos, cenários e setores */}
          <Stack>
            <Graphs data={data} />
            <Cenarios data={data} />
          </Stack>
        </Stack>
      </Stack>
    </ConsultaProvider>
  );
});

export default withMessage(ConsultaStressTest);
